/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientUser } from '../models/ClientUser';
import { request as __request } from '../core/request';

export class EsiaService {

    /**
     * @param requestBody
     * @returns ClientUser Ok
     * @throws ApiError
     */
    public static async authenticate(
        requestBody: {
            code: string,
            state: string,
        },
    ): Promise<ClientUser> {
        const result = await __request({
            method: 'POST',
            path: `/esia/auth`,
            body: requestBody,
            errors: {
                400: `Validation Failed`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns string Ok
     * @throws ApiError
     */
    public static async redirect(): Promise<string> {
        const result = await __request({
            method: 'GET',
            path: `/esia/redirect`,
            errors: {
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}